import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增组织架构
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyOrganization/save',
        method: 'post',
        data
    })
}
//修改组织架构
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyOrganization/update',
        method: 'post',
        data
    })
}
//查询组织架构列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyOrganization/list',
        method: 'get',
        params
    })
}
//查询组织架构
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyOrganization/detail?id=' + id,
        method: 'get',
    })
}
//删除组织架构
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyOrganization/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}